// extracted by mini-css-extract-plugin
export default {"ctn":"cooperation_ctn__dnR14","textBox":"cooperation_textBox__oKI2w"};